import { Fragment } from 'react';

import { TGameData, TParticipant } from '../../types';

import AdventCalendarGame from './AdventCalendarGame';
import AdventCalendarRawGame from './AdventCalendarRawGame';
import ChristmasFortuneWheelGame from './ChristmasFortuneWheelGame';
import ClassicFortuneWheel from './ClassicWheelGame';

type TGameProps = {
  game: TGameData;
  participant: TParticipant;
  userToken: string;
};

export const classicWheelId = 'wheel-fortune-classic';
export const estivalWheelId = 'wheel-fortune-estival';
export const fortuneWheelId = 'wheel-fortune-christmas';
export const adventCalendarId = 'advent-calendar';
export const adventCalendarRawId = 'advent-calendar-raw';
export const sirhaWheelId = 'wheel-fortune-sirha';
export const stickAndPlayWheelId = 'wheel-fortune-stick-and-play';
export const grippleWheelId = 'wheel-fortune-gripple';
export const ajinomotoWheelId = 'wheel-fortune-ajinomoto';
export const bmiValentinesDayWheelId = 'wheel-fortune-bmi-valentines-day';
export const losteWheelId = 'wheel-fortune-loste';

const index = ({ game, participant, userToken }: TGameProps) => {
  return (
    <Fragment>
      {game.animationType === classicWheelId && (
        <ClassicFortuneWheel game={game} participant={participant} userToken={userToken} footerColor="white" />
      )}
      {game.animationType === estivalWheelId && (
        <ClassicFortuneWheel
          game={game}
          participant={participant}
          userToken={userToken}
          imagesPath="assets/estivalWheel"
        />
      )}
      {game.animationType === sirhaWheelId && (
        <ClassicFortuneWheel
          game={game}
          participant={participant}
          userToken={userToken}
          imagesPath="assets/sirhaWheel"
          backgroundSize="100vw auto"
          backgroundMobileSize="100vw auto"
          hasMobileBackground
          backgroundRepeat={false}
        />
      )}
      {game.animationType === stickAndPlayWheelId && (
        <ClassicFortuneWheel
          game={game}
          participant={participant}
          userToken={userToken}
          imagesPath="assets/stickAndPlayWheel"
          backgroundSize="100vw auto"
          backgroundMobileSize="100vw auto"
          hasMobileBackground
          backgroundRepeat={false}
        />
      )}
      {game.animationType === grippleWheelId && (
        <ClassicFortuneWheel
          game={game}
          participant={participant}
          userToken={userToken}
          imagesPath="assets/grippleWheel"
          backgroundSize="100vw auto"
          backgroundMobileSize="100vw auto"
          hasMobileBackground
          backgroundRepeat={false}
        />
      )}
      {game.animationType === ajinomotoWheelId && (
        <ClassicFortuneWheel
          game={game}
          participant={participant}
          userToken={userToken}
          imagesPath="assets/ajinomotoWheel"
          backgroundSize="100vw auto"
          backgroundMobileSize="100vw auto"
          hasMobileBackground
          backgroundRepeat={false}
        />
      )}
      {game.animationType === bmiValentinesDayWheelId && (
        <ClassicFortuneWheel
          game={game}
          participant={participant}
          userToken={userToken}
          imagesPath="assets/bmiValentinesDayWheel"
          backgroundSize="100vw auto"
          backgroundMobileSize="100vw auto"
          hasMobileBackground
          backgroundRepeat={false}
        />
      )}
      {game.animationType === losteWheelId && (
        <ClassicFortuneWheel
          game={game}
          participant={participant}
          userToken={userToken}
          imagesPath="assets/losteWheel"
          backgroundSize="cover"
          backgroundMobileSize="100vw auto"
          hasMobileBackground
          backgroundRepeat={true}
          footerColor="#FFF"
        />
      )}
      {game.animationType === fortuneWheelId && (
        <ChristmasFortuneWheelGame game={game} participant={participant} userToken={userToken} />
      )}
      {game.animationType === adventCalendarId && (
        <AdventCalendarGame game={game} participant={participant} userToken={userToken} />
      )}
      {game.animationType === adventCalendarRawId && (
        <AdventCalendarRawGame game={game} participant={participant} userToken={userToken} />
      )}
    </Fragment>
  );
};

export default index;
